/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author David Hellmann [david@hellmann.io]
 * cards
 */

const map = {
    cfg:  {
        name: 'map',
        select: document.querySelector('.js-map-filter'),
        wrapper: document.querySelector('.js-map')
    },

    initFilter() {
        this.cfg.select.addEventListener('change', (event) => {
            // this.resetFilter();
            this.setFilterSelect(event);
        });

        Array.from(this.cfg.select.options).forEach((option) => {
            this.cfg.wrapper.classList.add(option.value);
        });
    },

    setFilterSelect(event) {
        event.preventDefault();

        // Remove all classes
        Array.from(this.cfg.select.options).forEach((option) => {
            this.cfg.wrapper.classList.remove(option.value);
        });

        if (this.cfg.select.value === '*') {
            Array.from(this.cfg.select.options).forEach((option) => {
                this.cfg.wrapper.classList.add(option.value);
            });
        } else {
            this.cfg.wrapper.classList.add(this.cfg.select.value);
        }

        // this.resizeAllGridItems();
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.select) {
                this.initFilter();
            }
        });
    }
};

export default map;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/map/_script.js